import styled from 'styled-components'

export const ShopGroupsSwitchesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
